import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import componentsReducer, { ComponentsReducers } from "@tCentro/Store/Components/ComponentsReducer";
import centroConnectDataReducer from "@tCentro/Store/Reducer/CENCentroConnectDataReducer";

(reducers as any).t_components = componentsReducer;
(reducers as any).t_centroConnect = centroConnectDataReducer;

type CustomReducers = {
    t_components: typeof componentsReducer;
    t_centroConnect: typeof centroConnectDataReducer;
};

// creating custom actions along our custom reducers & OOTB actions from AnyAction
export type CustomActions = Parameters<CustomReducers[keyof CustomReducers]>[1] | AnyAction;
